import {
  normalizeItemIconPath,
  resolveCdnAssetUrl,
  resolveFishItemIconUrl,
} from "../../map/map-item-icons.js";

function escapeHtml(value) {
  return String(value ?? "").replace(
    /[&<>"']/g,
    (char) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[char] || char,
  );
}

function resolveItemGrade(grade, isPrize) {
  const normalized = String(grade ?? "").trim().toLowerCase();
  if (isPrize === true || normalized === "prize" || normalized === "red") {
    return "red";
  }
  switch (normalized) {
    case "rare":
    case "yellow":
      return "yellow";
    case "highquality":
    case "high_quality":
    case "high-quality":
    case "blue":
      return "blue";
    case "general":
    case "green":
      return "green";
    case "trash":
    case "white":
      return "white";
    default:
      return "unknown";
  }
}

export function resolveFishGrade(fish) {
  return resolveItemGrade(fish?.grade, fish?.isPrize === true);
}

export function fishIdentityMarkup(fish, itemLookup = null, options = {}) {
  const grade = resolveFishGrade(fish);
  const fishId = Number.parseInt(fish?.fishId, 10);
  const name = String(fish?.name || `Fish ${fishId || "?"}`).trim();
  const itemId = Number.parseInt(fish?.itemId, 10);
  const iconUrl =
    resolveFishItemIconUrl(itemId || fish?.iconItemId, {
      iconItemId: fish?.iconItemId,
      iconImage: fish?.iconImage,
      itemLookup,
    }) ||
    resolveCdnAssetUrl(normalizeItemIconPath(fish?.encyclopediaIconImage)) ||
    "";
  const iconMarkup = iconUrl
    ? `<span class="fishy-item-icon-frame is-xs fishy-item-grade-${escapeHtml(grade)}"><img class="fishy-item-icon" src="${escapeHtml(iconUrl)}" alt="${escapeHtml(name)}" crossorigin="anonymous" loading="lazy" decoding="async"></span>`
    : `<span class="fishy-item-icon-frame is-xs fishy-item-grade-${escapeHtml(grade)}"><span class="fishy-item-icon-fallback fishy-item-grade-${escapeHtml(grade)}">${escapeHtml(name.charAt(0).toUpperCase() || "?")}</span></span>`;
  const labelClass = options.iconOnly === true
    ? "sr-only"
    : options.truncateLabel === false
      ? "fishy-domain-label fishy-item-label whitespace-nowrap"
      : "fishy-domain-label fishy-item-label truncate max-w-40";
  return `<span class="fishy-item-row fishy-item-grade-${escapeHtml(grade)}">${iconMarkup}<span class="${labelClass}">${escapeHtml(name)}</span></span>`;
}
